import React from "react";
import { BsGithub, BsLinkedin, BsPersonCircle } from "react-icons/bs";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t border-gray-200 bg-white">
      <div className="max-w-7xl mx-auto px-6 py-14">
        
        {/* Top Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          
          {/* Brand */}
          <div className="md:col-span-4 space-y-4">
            <div className="flex items-center gap-3">
          
              <span className="text-xl font-semibold text-gray-900">
              🫟 ChatLog
              </span>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed max-w-sm">
              A calm place to write, share ideas, and have meaningful conversations
              with people who care about thoughtful discussion.
            </p>
          </div>

          {/* Links */}
          <div className="md:col-span-2 space-y-3">
            <h4 className="text-sm font-semibold text-gray-900">
              Product
            </h4>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/" className="hover:text-gray-900">Home</Link></li>
              <li><Link to="/about" className="hover:text-gray-900">About</Link></li>
              <li><Link to="/search" className="hover:text-gray-900">Search</Link></li>
              <li><Link to="/posts/create" className="hover:text-gray-900">Write</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3 space-y-3">
            <h4 className="text-sm font-semibold text-gray-900">
              Support
            </h4>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/settings" className="hover:text-gray-900">Settings</Link></li>
              <li><Link to="/settings/contact" className="hover:text-gray-900">Contact</Link></li>
              <li><Link to="/settings/developer" className="hover:text-gray-900">Developer</Link></li>
              <li>
                <a
                  href="mailto:vikaschamyal@gmail.com"
                  className="hover:text-gray-900"
                >
                  Email support
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div className="md:col-span-3 space-y-3">
            <h4 className="text-sm font-semibold text-gray-900">
              Connect
            </h4>

            <div className="flex items-center gap-4">
              <a
                href="https://github.com/vikaschamyal"
                target="_blank"
                rel="noreferrer"
                className="p-2 rounded-full text-gray-500 hover:text-violet-600 hover:bg-violet-50 transition"
              >
                <BsGithub size={20} />
              </a>

              <a
                href="https://www.linkedin.com/in/vikas-chamyal24"
                target="_blank"
                rel="noreferrer"
                className="p-2 rounded-full text-gray-500 hover:text-violet-600 hover:bg-violet-50 transition"
              >
                <BsLinkedin size={20} />
              </a>

              <a
                href="https://portfolio-lac-six-83.vercel.app/"
                target="_blank"
                rel="noreferrer"
                className="p-2 rounded-full text-gray-500 hover:text-violet-600 hover:bg-violet-50 transition"
              >
                <BsPersonCircle size={20} />
              </a>
            </div>

            <p className="text-sm text-gray-500">
              Follow for updates and new features
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="mt-12 border-t border-gray-200 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} FLOWLINE. All rights reserved.
          </p>

          <div className="flex items-center gap-4 text-sm text-gray-500">
            <Link to="/terms" className="hover:text-gray-900">
              Terms
            </Link>
            <span>·</span>
            <Link to="/privacy" className="hover:text-gray-900">
              Privacy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
